<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title label-black">Detalles de la Incidencia</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="row">
                            <div class="form-group col-6">
                                <label class="label-black">Folio</label>
                                <input type="text" class="form-control" v-model="detalles.IncidenciaId" readonly />
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Estatus</label>
                                <input type="text" class="form-control" v-model="detalles.EstatusIncidencia.Nombre" readonly />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6">
                                <label class="label-black">Tipo de Incidencia</label>
                                <input type="text" class="form-control" v-model="detalles.TipoIncidencia.Nombre" readonly />
                            </div>
                            <div class="form-group col-6" v-if="detalles.TipoSubIncidencia!=null">
                                <label class="label-black">Categoria</label>
                                <input type="text" class="form-control" v-model="detalles.TipoSubIncidencia.Nombre" readonly />
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==1">
                        <div class="row">
                            <div class="form-group col-4" >
                                <label class="label-black">Fecha</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-4" >
                                <label class="label-black">Hora de Salida</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.HoraSalida" readonly/>
                            </div>
                            <div class="form-group col-4" >
                                <label class="label-black">Hora de Entrada</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.HoraEntrada" readonly />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.Motivo" readonly />
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==2 && detalles.TipoSubIncidencia.TipoSubIncidenciaId==1">  <!-- Dia Economico -->
                        <div class="row d-flex align-items-center">
                            
                            <div class="form-group col-4" >
                                <div id="diasEconomicos_table" class="table-responsive">
                                    <table class="table table-striped table-light table-hover table-sm">
                                        <thead class="thead-custom">
                                            <tr>
                                            <th class="text-center">total de dias: {{detalles.Detalles.length}}</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            <tr v-for="dias in listadoDetalle" :key="dias.IncidenciaDetalleId">
                                                <td v-html="obtenFechaConFormato(dias.Dia)" class="text-center" v-if="Editar ==false"></td>
                                                <td v-else>
                                                    <input type="date" class="form-control" v-model="dias.Dia"/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="form-group col-8">
                                <label class="label-black">Motivo</label>
                                <textarea type="text" v-model="mostrarDetalle.Motivo" rows="4" class="form-control"  placeholder="Escriba algun motivo para el pase Intermedio" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==2 && detalles.TipoSubIncidencia.TipoSubIncidenciaId==2"> <!-- Dia Vacaciones -->
                        <div class="row align-items-center">
                            <div class="form-group col-4" >
                                <label class="label-black">Año</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.Anio" readonly/>
                            </div>
                            <div class="form-group col-4">
                                <label class="label-black">Período Vacacional</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.Periodo" readonly/>
                            </div>
                            <div class="form-group col-4" >
                                <label class="label-black">Días en Período</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.DiasVacaciones" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio" @change="ObtenerDias(mostrarDetalle.FechaInicio, mostrarDetalle.FechaTermino)"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino" @change="ObtenerDias(mostrarDetalle.FechaInicio, mostrarDetalle.FechaTermino)"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==2 && detalles.TipoSubIncidencia.TipoSubIncidenciaId==3"> <!-- Sustitucion de Dia -->
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Día que Solicita</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.DiaSustitucion" readonly/>
                            </div>
                            <div class="form-group col-6" v-if="Editar==false">
                                <label class="label-black">Por el Día</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.DiaOriginal" readonly />
                            </div>
                            <!-- <div class="form-group col-6" v-if="Editar==false">
                                <label class="label-black">Por el Día</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.DiaSustitucion"/>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.Motivo" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==3 && detalles.TipoSubIncidencia.TipoSubIncidenciaId==4">
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">De</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.HoraInicio" readonly/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Hasta</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.HoraFinal" readonly/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-3">
                                <label >Anexa Constancia</label>
                            </div>
                            <div class="form-group col-6">
                                <input type="checkbox" v-model="mostrarDetalle.Constancia" disabled>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==3 && detalles.TipoSubIncidencia.TipoSubIncidenciaId ==5">
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">De</label>
                                <input type="time" class="form-control" v-model="mostrarDetalle.HoraInicio" readonly/>
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Hasta</label>
                                <input type="time" class="form-control" v-model="mostrarDetalle.HoraFinal" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==3 && detalles.TipoSubIncidencia.TipoSubIncidenciaId ==6">
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.Motivo" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==4 && (detalles.TipoSubIncidencia.TipoSubIncidenciaId ==7 || detalles.TipoSubIncidencia.TipoSubIncidenciaId ==8 || detalles.TipoSubIncidencia.TipoSubIncidenciaId ==10 )">
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Licencia con goce de sueldo Art.47 del Reglamento interior de Trabajo</h6>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Nombre</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.Nombre" readonly/>   
                            </div>
                            <div class="form-group col-6" >
                                <label class="label-black">Parentesco</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.Parentesco" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio" />
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino" />
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==4 && (detalles.TipoSubIncidencia.TipoSubIncidenciaId ==9 || detalles.TipoSubIncidencia.TipoSubIncidenciaId ==11)">
                        <div class="row">
                            <div class="form-group col-12" >
                                <h6>Licencia con goce de sueldo Art.47 del Reglamento interior de Trabajo</h6>
                            </div>
                        </div>
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio" />
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino" />
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==5 && detalles.TipoSubIncidencia.TipoSubIncidenciaId ==12">
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio" @change="ObtenerDiasMatenidad(mostrarDetalle.FechaInicio)"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Otra Solicitud</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.OtraSolicitud" />
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==5 && detalles.TipoSubIncidencia.TipoSubIncidenciaId ==13">
                      <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio" />
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Otra Solicitud</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.OtraSolicitud" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==6 || detalles.TipoIncidencia.TipoIncidenciaId==7 ">
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio" />
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" rows=4 class="form-control" v-model="mostrarDetalle.Motivo" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==8 && (detalles.TipoSubIncidencia.TipoSubIncidenciaId ==14 || detalles.TipoSubIncidencia.TipoSubIncidenciaId ==15) ">
                        <div class="row align-items-center">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.Motivo" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==9 && (detalles.TipoSubIncidencia.TipoSubIncidenciaId ==16 || detalles.TipoSubIncidencia.TipoSubIncidenciaId ==17) ">
                        <div class="row">
                            <div class="form-group col-6" >
                                <label class="label-black">Fecha</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.Motivo" />
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.TipoIncidencia.TipoIncidenciaId==10 ">
                        <div class="row align-items-center" v-if="Editar==false">
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaInicio" readonly/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="text" class="form-control" v-model="mostrarDetalle.FechaTermino" readonly/>
                            </div>
                        </div>
                        <div class="row align-items-center" v-else>
                            <div class="form-group col-6" >
                                <label class="label-black">Inicio</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaInicio"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="label-black">Termino</label>
                                <input type="date" class="form-control" v-model="mostrarDetalle.FechaTermino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo</label>
                                <textarea type="text" class="form-control" v-model="mostrarDetalle.Motivo" readonly/>
                            </div>
                        </div>
                    </div>
                    <div v-if="detalles.EstatusIncidencia.TipoEstatusIncidenciaId==4">
                        <div class="row">
                            <div class="form-group col-12" >
                                <label class="label-black">Motivo de Cancelación</label>
                                <textarea type="text" rows="3" class="form-control" v-model="detalles.MotivoCancelacion" readonly/>
                            </div>
                        </div>
                        <div class="row" v-if="detalles.UsuarioIdQuienCancela!=null">
                            <div class="form-group col-12" >
                                <label class="label-black">Usuario quien Canceló</label>
                                <input type="text" rows="4" class="form-control" v-model="detalles.UsuarioIdQuienCancela.Nombres" readonly/>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="form-group col-12" >
                                <label class="label-black">Usuario quien Canceló</label>
                                <input type="text" rows="4" class="form-control" readonly/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
                    <button type="button" class="btn btn-custom" id="botonRegistrar" v-if="Editar==true">Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
export default {
    props: {
        detalles: Object,
        InfoDigital: Object,
        InfoCancelacion: Object,
        Editar: {type : Boolean, default: false},
        ListadoInhabiles: Array,
        diasModal: {type: Number, default: 0},
        listadoIncidencias: Array,
        Nomina: {type: Number, default: 0}
    },
    data(){
        return{
            mostrarDetalle:{
                IncidenciaDetalleId :null,
                Dia: null,
                HoraEntrada: null,
                HoraSalida: null,
                HoraInicio: null,
                HoraFinal: null,
                Motivo: null,
                Nombre: null,
                Parentesco: null,
                FechaInicio: null,
                FechaTermino: null,
                Constancia: null,
                Periodo: null,
                Anio: null,
                DiasVacaciones: null,
                DiaOriginal: null,
                DiaSustitucion: null,
                OtraSolicitud: null,
            },
            listadoDetalle: [],
            DiasVacacionesDisponibles: 0,
            temporal: {
                FechaInicio: null,
                FechaTermino: null,
                DiasVacaciones: null,
                DiaSustitucion: null
            },
            CamposEditados: []
            
        }
    },
    methods:{
        Mostrar: function () {
            $('#modalEnvio').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonRegistrar').unbind('click').click(this.RegistraCambios);
            },
        ModalClose: function(b1, b2, nom){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('Estatus',  {'Cerrar': b1, 'Actualizar': b2, 'Nomina':nom});
        },
        obtenFechaConFormato: function(fechaDia) {
            return moment(fechaDia).format("DD-MM-YYYY");
        },
        Periodo(periodo){
            var Texto =""
            if(periodo==1)
            {
                Texto="Primero";
            };
            if(periodo ==2)
            {
                Texto="Segundo"
            };
            return Texto;
        },
        FormatoDatos(lista)
        {   var listaTemporal =[];
            
            if(this.detalles.TipoIncidencia.TipoIncidenciaId==2)
            {   
                if(this.detalles.TipoSubIncidencia.TipoSubIncidenciaId==1)
                {
                    this.mostrarDetalle.Motivo= lista[0].Motivo;
                    $.each(lista, function(index, incidencia)
                    {
                        var formatoDia= this.Editar==false ? moment(incidencia.Dia).format('DD-MM-YYYY') : moment(incidencia.Dia).format('YYYY-MM-DD') ;
                        //incidencia.Dia = formatoDia;
                        listaTemporal.push({
                            "IncidenciaDetalleId": incidencia.IncidenciaDetalleId,
                            "Dia": formatoDia});
                    }); 
                }
            }
            
                this.mostrarDetalle.IncidenciaDetalleId = lista[0].IncidenciaDetalleId;
                this.mostrarDetalle.Dia = moment(lista[0].Dia).format('DD-MM-YYYY')
                this.mostrarDetalle.HoraEntrada= lista[0].HoraEntrada;
                this.mostrarDetalle.HoraSalida= lista[0].HoraSalida;
                this.mostrarDetalle.HoraInicio= lista[0].HoraInicio;
                this.mostrarDetalle.HoraFinal= lista[0].HoraFinal;
                this.mostrarDetalle.Motivo= lista[0].Motivo;
                this.mostrarDetalle.Nombre= lista[0].Nombre;
                if(lista[0].Parentesco!=null)
                {
                    this.mostrarDetalle.Parentesco= lista[0].Parentesco.Nombre;
                }
                if(lista[0].FechaInicio!=null){
                    this.mostrarDetalle.FechaInicio= this.Editar==false ? moment(lista[0].FechaInicio).format('DD-MM-YYYY') : moment(lista[0].FechaInicio).format('YYYY-MM-DD') ;
                    this.temporal.FechaInicio = this.Editar==false ? moment(lista[0].FechaInicio).format('DD-MM-YYYY') : moment(lista[0].FechaInicio).format('YYYY-MM-DD');
                };
                if(lista[0].FechaTermino!=null){
                    this.mostrarDetalle.FechaTermino= this.Editar==false ? moment(lista[0].FechaTermino).format('DD-MM-YYYY') : moment(lista[0].FechaTermino).format('YYYY-MM-DD');
                    this.temporal.FechaTermino =  this.Editar==false ? moment(lista[0].FechaTermino).format('DD-MM-YYYY') : moment(lista[0].FechaTermino).format('YYYY-MM-DD');
                };
                if(lista[0].DiaOriginal!=null){
                    this.mostrarDetalle.DiaOriginal= moment(lista[0].DiaOriginal).format('DD-MM-YYYY');
                }
                if(lista[0].DiaSustitucion!=null){
                    this.mostrarDetalle.DiaSustitucion= this.Editar==false ? moment(lista[0].DiaSustitucion).format('DD-MM-YYYY') : moment(lista[0].DiaSustitucion).format('YYYY-MM-DD');
                    this.temporal.DiaSustitucion = this.Editar==false ? moment(lista[0].DiaSustitucion).format('DD-MM-YYYY') : moment(lista[0].DiaSustitucion).format('YYYY-MM-DD');
                }
                this.mostrarDetalle.Constancia= lista[0].Constancia;
                this.mostrarDetalle.Periodo= this.Periodo(lista[0].Periodo);
                this.mostrarDetalle.Anio= lista[0].Anio;
                this.mostrarDetalle.DiasVacaciones= lista[0].DiasVacaciones;
                this.temporal.DiasVacaciones = lista[0].DiasVacaciones;
                this.mostrarDetalle.OtraSolicitud= lista[0].OtraSolicitud; 
            
            this.listadoDetalle = listaTemporal;
            
        },
        RegistraCambios(){
            
            var IncidenciaDetalles = [];
            var EjecutarApi=false;
            var ModalMensaje= false;
            var CamposModificados = "";

            if(this.listadoDetalle.length==0)
            {
                if(this.mostrarDetalle.FechaInicio == this.temporal.FechaInicio && this.mostrarDetalle.FechaTermino == this.temporal.FechaTermino && this.mostrarDetalle.DiaSustitucion == this.temporal.DiaSustitucion)
                {
                    EjecutarApi=false;
                }
                else
                {
                    var valor = this.VerificarDiasEnIncidencias(this.mostrarDetalle);
                    if(valor.Estatus==false)
                    {
                        IncidenciaDetalles.push(this.mostrarDetalle);
                        EjecutarApi = true;
                        if(this.mostrarDetalle.FechaInicio != this.temporal.FechaInicio)
                        {
                            CamposModificados += "Fecha de Incio: "+ this.temporal.FechaInicio + ", "
                        };
                        if(this.mostrarDetalle.FechaTermino != this.temporal.FechaTermino)
                        {
                            CamposModificados += "Fecha de Termino: "+ this.temporal.FechaTermino + ", "
                        };
                        if(this.mostrarDetalle.DiaSustitucion != this.temporal.DiaSustitucion)
                        {
                            CamposModificados += "Dia Sustitucion: "+ this.temporal.DiaSustitucion + ", "
                        }
                        this.CamposEditados.push({
                            "IncidenciaDetalleId": this.mostrarDetalle.IncidenciaDetalleId,
                            "Modificacion": CamposModificados
                        });
                    }
                    else
                    {
                        comun.mensajeDeAlerta("El Periodo especificado tiene dias de otra Incidencia Registrada No: " + valor.Incidencia, null, null);
                        EjecutarApi = false;
                        ModalMensaje = true;
                    };
                }
            }
            else
            {
                let _this = this;
                var checkListado = 0;
                var TestList= this.detalles.Detalles;
                var listadoBitacora = [];
                $.each(this.listadoDetalle, function(index, dias)
                {
                    var obtenerId = TestList.filter(a=>a.IncidenciaDetalleId == dias.IncidenciaDetalleId);
                    var diaAVerificar = moment(dias.Dia).format('YYYY-MM-DD') + "T00:00:00";
                    if(TestList.filter(e=>e.Dia==diaAVerificar).length==0)
                    {
                        checkListado+=1;
                        
                        CamposModificados += "Dia No. " + checkListado + " : " + moment(obtenerId[0].Dia).format('DD-MM-YYYY') + ", ";
                        listadoBitacora.push({
                            "IncidenciaDetalleId": dias.IncidenciaDetalleId,
                            "Modificacion": CamposModificados
                        });
                        CamposModificados = "";
                    };
                })
                if(checkListado>0)
                {
                    var contadorEmpalme = 0;
                    var IncidenciasString =""
                    $.each(this.listadoDetalle, function(index, dias)
                    {
                        var valor= _this.VerificarDiasEnIncidencias(dias);
                        if(valor.Estatus==true)
                        {
                            contadorEmpalme += 1;
                            IncidenciasString += valor.Incidencia +",";
                        }
                    });
                    if(contadorEmpalme == 0)
                    {
                        EjecutarApi = true;
                        IncidenciaDetalles = this.listadoDetalle;
                    }
                    else
                    {
                        EjecutarApi = false;
                        ModalMensaje = true;
                        comun.mensajeDeAlerta("El Periodo especificado tiene dias de otra Incidencia Registrada No: " + IncidenciasString, null, null);
                    }
                }
                else
                {
                    EjecutarApi = false;
                }
                this.CamposEditados = listadoBitacora;
            };

            //llamos la api para registrar los cambios
            if(EjecutarApi==true)
            {
                var Incidencia= this.detalles;
                var Bitacora= this.CamposEditados;
                var Detalles = IncidenciaDetalles
                var peticion= {
                    Incidencia,
                    Detalles,
                    Bitacora
                };
                
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.SIAP.funcion.ModificarIncidencia, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then(respuesta => {
                    if (respuesta.data.SiHayError){
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        comun.SeEstaCargandoInformacion(false);
                    }
                    else
                    {
                        comun.mensajeDeAlerta("Se ha Registrado el Cambio en la Incidencia", null, null);
                        comun.SeEstaCargandoInformacion(false);
                        this.ModalClose(false, true, this.Nomina);
                    }
                    comun.SeEstaCargandoInformacion(false);
                    
                })
                .catch(e=> {
                    console.log("No Hay Respuesta del Servidor", e);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                });
            }
            else
            {
                if(ModalMensaje==false)
                {
                    this.ModalClose(false, false, undefined);
                }
                
            }
        },
        ValidamosCampos(){
             if(this.mostrarDetalle.FechaInicio !=null && this.mostrarDetalle.FechaTermino !=null)
             {
                 if( this.mostrarDetalle.FechaInicio > this.mostrarDetalle.FechaTermino)
                 {
                     comun.mensajeDeAlerta("Fecha de Inicio no puede ser mayor a Fecha de Termino", null, null);
                     return false;
                 }
             };
             return true;
        },
        ObtenerDias(inicio, fin){
            
            var DiasIniciales = 10 - this.diasModal;
            
            var contador=0;
            var FechaInicial= moment(inicio);
            var FechaFinal = moment(fin);
            var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
            
            var i;
            for (i = 0; i < Diff; i++) {
                var diaAVerificar;
                if(i==0)
                    {
                        diaAVerificar=FechaInicial.add({'days': i}).format('YYYY-MM-DD') + 'T00:00:00';
                    }
                else
                    {
                        diaAVerificar=FechaInicial.add({'days': 1}).format('YYYY-MM-DD') + 'T00:00:00';
                    };
               
                if(this.ListadoInhabiles.filter(a=> a.C023DiaInhabil==diaAVerificar).length == 0)
                {
                    contador=contador +1; 
                }
                
            };
            var DiasSumados = DiasIniciales - contador;
            this.mostrarDetalle.DiasVacaciones = contador;
            
            if(DiasSumados<0)
            {
                comun.mensajeDeAlerta("Los días solicitados sobrepasa a los días disponibles", null, null);
                this.mostrarDetalle.FechaInicio = this.temporal.FechaInicio;
                this.mostrarDetalle.FechaTermino = this.temporal.FechaTermino;
                this.mostrarDetalle.DiasVacaciones = this.temporal.DiasVacaciones;
            }
        },
        VerificarDiasEnIncidencias: function (datos){
            var listado = this.listadoIncidencias.filter(i=>i.IncidenciaId!=this.detalles.IncidenciaId);
            var anioCorriente = moment().format('YYYY');
            var Incidencias =[];
            var ListadoDiasIncidencias = [];
            Incidencias = listado.filter(e=>e.TipoIncidencia.TipoIncidenciaId!=1 && e.TipoIncidencia.TipoIncidenciaId!=8 && e.TipoIncidencia.TipoIncidenciaId!=9 && e.EstatusIncidencia.TipoEstatusIncidenciaId!= 4);
            $.each(Incidencias, function (index, diasTramitados)
            {
                
                $.each(diasTramitados.Detalles, function(index, contenido){
                    if(contenido.Dia!=null)
                    {
                        if(moment(contenido.Dia).format('YYYY') == anioCorriente)
                        {
                            ListadoDiasIncidencias.push({"Dia": moment(contenido.Dia).format('YYYY-MM-DD'), "IncidenciaId": diasTramitados.IncidenciaId })
                        }
                    }
                    if(contenido.FechaInicio!=null && contenido.FechaTermino!=null)
                    {
                        var FechaInicial= moment(contenido.FechaInicio);
                        var FechaFinal = moment(contenido.FechaTermino);
                        var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
                        var i;
                        for (i = 0; i < Diff; i++)
                            {   
                                var dia =moment(contenido.FechaInicio).add({'days': i}).format('YYYY-MM-DD');
                                ListadoDiasIncidencias.push({'Dia': dia, "IncidenciaId": diasTramitados.IncidenciaId});
                            }
                    }
                    if(contenido.DiaSustitucion!=null)
                    {
                        if(moment(contenido.DiaSustitucion).format('YYYY') == anioCorriente)
                        {
                            ListadoDiasIncidencias.push({"Dia": moment(contenido.DiaSustitucion).format('YYYY-MM-DD'), "IncidenciaId": diasTramitados.IncidenciaId })
                        }
                    }
                });
                
            });

            if(datos.Dia!=null)
                {
                    var filtro = ListadoDiasIncidencias.filter(e=>e.Dia==moment(datos.Dia).format('YYYY-MM-DD'));
                    if(filtro.length>0)
                    {
                        var resp = { "Estatus": true, "Incidencia": filtro[0].IncidenciaId}
                        return resp;
                    }  
                };
            
            if(datos.FechaInicio!=null && datos.FechaTermino!=null)
                {
                    var FechaInicial= moment(datos.FechaInicio);
                    var FechaFinal = moment(datos.FechaTermino);
                    var Diff = FechaFinal.diff(FechaInicial, 'days') + 1;
                    var i;
                    for (i = 0; i < Diff; i++)
                    {   
                    var dia =moment(datos.FechaInicio).add({'days': i}).format('YYYY-MM-DD');
                       var filtro =ListadoDiasIncidencias.filter(e=>e.Dia==dia);
                        if(filtro.length>0)
                        {
                            var resp = { "Estatus": true, "Incidencia": filtro[0].IncidenciaId}
                            return resp;
                        }
                    }
                }
            if(datos.DiaSustitucion!=null)
                {
                    var filtro = ListadoDiasIncidencias.filter(e=>e.Dia==moment(datos.DiaSustitucion).format('YYYY-MM-DD'))
                    if(filtro.length>0){
                    var resp = { "Estatus": true, "Incidencia": filtro[0].IncidenciaId}
                    return resp; } 
                }
            var resp2 = { "Estatus": false, "Incidencia": 0}
            return resp2;
        },
        ObtenerDiasMatenidad(datos)
        {
            var fecha1= moment(datos);
            var fecha2 = fecha1.add(84, 'days').format('YYYY-MM-DD');
            this.mostrarDetalle.FechaTermino = fecha2;
        }
    },
    mounted(){
        this.FormatoDatos(this.detalles.Detalles);
        this.Mostrar();
    }
}
</script>
<style scoped>
.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    outline: 0;
}
input[type="text"]:read-only {
    background: #f3f3f3;
}
textarea[type="text"]:read-only {
    background: #f3f3f3;
}
input[type="text"]:read-only:focus {
    color: #fff;
}
textarea[type="text"]:read-only:focus {
    color: #fff;
}
.thead-custom {
        background-color: #004746;
        color: white;
    }
.modal-content {
        background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/SIAP/Incidencias/ModalDetalles.vue